import { H4 } from '@liveauctioneers/hammer-ui-core/text';
import { memo, ReactNode } from 'react';

const DEFAULT_EMPTY_MESSAGE = 'No conversations here!';

type Props = {
    readonly message?: ReactNode;
    readonly testid?: string;
};

const NoConversationsComponent = ({ message = DEFAULT_EMPTY_MESSAGE, testid = 'messengerNoConversations' }: Props) => {
    return (
        <div
            className="flex flex-col items-center justify-center border border-border-secondary bg-surface-100 px-lg pb-md pt-[23px] text-center"
            data-testid={testid}
        >
            <H4>{message}</H4>
        </div>
    );
};

export const NoConversations = memo<Props>(NoConversationsComponent);
